import React, { useContext } from 'react'
import {
  createFormattedDateFromDate,
  createFormattedDateFromStr,
  getDayOfWeek
} from './helpers/dateFunctions'
import { DataContext, StyleContext } from './GanttChart'

const WeekRow = () => {
  const { startMonth, curYear, curMonth, numDays } = useContext(DataContext)
  const { columnValue, lockHeight } = useContext(StyleContext)
  const ganttTimePeriod = {
    display: 'grid',
    gridAutoFlow: 'column',
    gridAutoColumns: `minmax(${columnValue}px, 1fr)`,
    outline: '0.5px solid #e9eaeb',
    textAlign: 'center',
    height: '72px'
  }

  let weekRow = []
  for (let j = 1; j <= numDays; j++) {
    const formattedDate = createFormattedDateFromStr(curYear, curMonth, j)

    weekRow.push(
      <div
        key={j}
        style={{
          ...ganttTimePeriod,
          outline: 'none',
          border: '1px solid darkgrey',
          height: '50px',
          backgroundColor:
            formattedDate === createFormattedDateFromDate(new Date())
              ? '#0075C9'
              : '#fff',
              color:'#fff',
              
        }}
      >
        <span style={{ margin: 'auto', color:
            formattedDate === createFormattedDateFromDate(new Date())
              ? '#ffffff'
              : '#000000', }}>
          {getDayOfWeek(curYear, curMonth - 1, j - 1)}
          <br />
       <strong style={{color:
            formattedDate === createFormattedDateFromDate(new Date())
              ? '#ffffff'
              : '#000000',}}>  {startMonth.getMonth() + 1} / {j}
        </strong></span>
      </div>
    )
  }

  return (
    <div
      style={{
        ...ganttTimePeriod,
        outline: 'none',
        height: '51px',
        position:'sticky',
        top:'0px',  
        bottom:'0px',          
        zIndex:'999'

      }}
    >
      {weekRow}
    </div>
  )
}

export default WeekRow
